// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1DJXT","body":"Modal_body__2wHIm","icon":"Modal_icon__3Wp-K","title":"Modal_title__3K3sY","desc":"Modal_desc__1LL0o","btn":"Modal_btn__3yUBA"};